<template>
  <div class="nav-search" v-on="$attrs" @click.stop="handleHrefClick">
    <div class="nav-search-wrapper">
      <div class="nav-search-input-icon" @click="search('search-icon-click')">
        <icon
          type="search"
          class="search-icon"
          :class="searchIconClass"
        />
      </div>
      <input
        ref="input-search"
        class="nav-search-input"
        :placeholder="placeholder"
        @focus="isFocus = true"
        @keydown.enter="search('enter')"
        @click="handleInputClick"
        v-model.trim="keyword"
      />
      <transition name="fade">
        <div class="nav-search-delete-wrapper" v-if="keyword && keyword.length > 0 && showClear">
          <img
            class="nav-search-delete"
            src="~/assets/image/search_del.png"
            @click="handleClear"
            alt=""
          />
        </div>
      </transition>
      <button class="nav-search-button" v-if="showSearchButton" @click.stop="search('click')">搜索</button>
    </div>

    <template v-if="hotwordList.length !== 0 || historyList.length !== 0">
      <history
        class="nav-search-history"
        v-show="isFocus && !keyword"
        :hotwordList="hotwordList"
        :historyList="historyList"
        @del-history="delHistory"
        @clear-history="clearHistory"
        :splitCol="splitCol"
      ></history>

      <associate
        class="nav-search-associate"
        v-show="isFocus && keyword && associateList.length > 0"
        :associateList="associateList"
        @click="handleAssociateClick"
      ></associate>
    </template>
  </div>
</template>

<script>
import History from './history';
import Associate from './associate';
import storage from '@/common/utils/storage';
import { getSearchUrl, debounce } from '@/common/utils';
import { SEARCH_HISTORY_KEY } from '@/common/constant/storage-key';

export default {
  data() {
    return {
      keyword: this.$store.state.common.keyword || '',
      isFocus: false,

      hotwordList: [],
      historyList: [],
      associateList: [],

      hotWordTimer: null, // 滚动热词的计时器
      currentHotWord: '' // 当前滚动的热词
    };
  },

  components: {
    History,
    Associate
  },

  props: {
    showSearchButton: { // 是否需要展示搜索按钮
      type: Boolean,
      default: false
    },
    splitCol: {
      type: Number,
      default: 1
    },
    showClear: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: 'navbar-search'
    }
  },

  watch: {
    isFocus(val) {
      if (val) {
        this.$emit('focus');
      } else {
        this.$emit('blur');
        this.associateList = [];
      }
    },

    keyword() {
      this.debounceGetAssociateList && this.debounceGetAssociateList();
    },

    '$store.state.common.keyword': {
      immediate: true,
      handler(val) {
        this.keyword = val;
      },
    },

  },

  computed: {
    firstHotword() {
      const item = this.hotwordList[0];
      return item && item.title;
    },

    placeholder() {
      return this.currentHotWord || this.firstHotword || '请输入关键词';
    },

    searchIconClass() {
      return { 'search-icon-active': this.isFocus };
    }
  },

  methods: {
    // 监听a标签跳转搜索，记录历史
    handleHrefClick(e) {
      const target = e.target;
      const keyword = target.getAttribute('data-keyword');

      if (target.tagName.toLocaleLowerCase() === 'a' && keyword) {
        this.addHistory(keyword);
      }
    },

    // 监听input点击
    handleInputClick() {
      this.historyList = (storage.get(SEARCH_HISTORY_KEY) || []).slice(0, 5);
      if (this.source == 'navbar-search') {
        this.$collect.nav_click({ click: 'seach' });
      }

      this.$collect.homepageSearchClick({
        action: 'entrance',
        keyword: this.keyword,
      });
    },

    // 添加单个记录
    addHistory(word) {
      const list = [...this.historyList];
      const idx = list.findIndex((item) => item === word);

      // 如已有该搜索词，则置顶搜索词
      if (idx !== -1) {
        list.splice(idx, 1);
      }

      this.historyList = [word, ...list].slice(0, 5);
      storage.set(SEARCH_HISTORY_KEY, this.historyList);
    },

    // 删除单个记录
    delHistory(word) {
      const list = [...this.historyList];
      const idx = list.findIndex((item) => item === word);
      list.splice(idx, 1);
      this.historyList = list;
      storage.set(SEARCH_HISTORY_KEY, this.historyList);
    },

    // 清除所有记录
    clearHistory() {
      this.historyList = [];
      storage.set(SEARCH_HISTORY_KEY, this.historyList);
    },

    /**
     * 执行搜索
     * @param {String} action 点击来源
     */
    search(action) {
      this.$emit('search', { action });
      const { keyword } = this;
      const word = keyword || this.currentHotWord || this.firstHotword;

      switch(this.source) {
        case 'home-search':
          if (action == 'enter') {
            this.$collect.homePageClick({ click: 'seach_enter' });
          } else if (action == 'click') {
            this.$collect.homePageClick({ click: 'seach_click' });
          }
          break;
        default:
          if (action == 'search-icon-click') {
            this.$collect.nav_click({ click: 'seach_click' });
          } else if (action == 'enter') {
            this.$collect.nav_click({ click: 'seach_enter' });
          }
      }

      this.$collect.homepageSearchClick({ action, keyword: word });

      if (!word) return;

      this.addHistory(word);
      location.href = getSearchUrl(word);
    },

    // 获取联想词
    async getAssociateList() {
      if (!this.keyword) {
        this.associateList = [];
        return;
      }

      const { data = [] } = await this.$service.learning.getSearchAssociate(
        this.keyword
      );

      this.associateList = data;
    },

    // 点击其他的地方才算模糊
    globalClickListener() {
      this.isFocus = false;
    },

    // 清除搜索框
    handleClear() {
      this.keyword = '';
    },

    startRollHotWordTimer() {
      let count = 0;
      this.hotWordTimer = setInterval(() => {
        // 滚动的热词，最多取6个词，两秒切换一次
        const list = this.hotwordList.slice(0, 6);
        if (count < list.length) {
          this.currentHotWord = list[count] && list[count].title;
          count += 1;
        } else {
          count = 0;
        }
      }, 2000);
    },

    handleAssociateClick({ keyword }) {
      this.addHistory(keyword);
    },

    handleInputFocus() {
      setTimeout(() => { // 异步执行聚焦
        this.$refs['input-search'].focus();
      }, 0);
    }
  },

  beforeDestroy() {
    document.removeEventListener('click', this.globalClickListener);
  },

  async mounted() {
    const { data = [] } = await this.$service.learning.getHotWords();

    this.hotwordList = data;
    this.historyList = storage.get(SEARCH_HISTORY_KEY) || [];

    // 监听全局click
    document.addEventListener('click', this.globalClickListener);

    // 设置防抖拉取联想词
    this.debounceGetAssociateList = debounce(this.getAssociateList, 300);

    // 启动热词轮播
    this.startRollHotWordTimer();
  },
};
</script>

<style lang="scss" scoped>
.nav-search {
  position: relative;
  width: 180px;
  height: 100%;
  @include flex-align-center();
  transition: all 0.3s ease;

  &-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    height: 32px;
    background: #F2F3F5;
    border-radius: 16px;
  }

  &-input {
    flex: 1;
    height: 100%;
    overflow: hidden;
    padding: 0 37px;
    border-radius: 16px;
    background: #F2F3F5;
    border: none;
  }

  &-input-icon {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    color: #8C939F;
    cursor: pointer;
    .search-icon {
      color: #8C939F;
      vertical-align: 1px;
    }
    .search-icon-active {
      color: #333840;
    }
  }

  &-delete-wrapper {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    &:hover {
      background: rgba(8, 48, 93, 0.08);
    }
    &:active:not(:disabled) {
      background: rgba(8, 48, 93, 0.16);
    }
    cursor: pointer;
    margin-right: 12px;
  }

  &-delete {
    width: 16px;
    height: 16px;
    display: inline-block;
  }

  &-button {
    background: #2C71FA;
    border-radius: 100px;
    width: 88px;
    padding: 5px 23px;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    cursor: pointer;
    margin-right: 8px;
    &:hover {
      background: #5794FF;
    }
    &:active {
      background: #1C53D4;
    }
  }

  .nav-search-history,
  .nav-search-associate {
    position: absolute;
    top: 48px;
    right: 0;
    box-shadow: 0px 12px 24px 0px rgba(17, 19, 23, 0.2);
    border-radius: 16px;
    border: 1px solid #D0D3D8;
  }

  .fade-enter{
    opacity: 0;
  }
  .fade-enter-active{
    transition: opacity .1s linear;
  }
  .fade-leave-to{
    opacity: 0;
  }
  .fade-leave-active{
    transition: opacity .1s linear;
  }
}
</style>
